import React from "react";
import {Maps} from "./Maps"

export const Contacto = (props) => {
  
  const handleClickWhatsaap = () => {
    window.open(props.data.whatsaap, '_blank')
  }
  const handleClickFacebook = () => {
    window.open(props.data.facebook, '_blank')
  }
  const handleClickInstagram = () => {
    window.open(props.data.instagram, '_blank')
  }
  const handleClickYoutube = () => {
    window.open(props.data.youtube, '_blank')
  }
  return (
<div>
    <div id="contacto">
     
       
      <div id="qodef-content-bottom">
        <div id="qodef-content-bottom-inner" className="qodef-content-grid">
       <div><Maps/></div>

          <div className="col-md-4 col-md-offset-1 contacto-info">

            <div className="contacto-item">
              <h3>Contacto Info</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Visitanos
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contacto-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Atencion al Cliente
                </span>{" "}
                {props.data ? props.data.phoneCarlos : "loading"}<br></br>
                {props.data ? props.data.phoneJefry : "loading"}
              </p>
            </div>
            <div className="contacto-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>

        <div id="shiftup_core_button-2" className="widget widget_shiftup_core_button" data-area="content-bottom">
          <a onClick={handleClickWhatsaap} className="qodef-shortcode qodef-m qodef-button qodef-layout--filled qodef-size--large qodef-html--link qodef-has-arrow" target="_self" style={{margin: '112px 0 0 40px'}}>
              <svg className="qodef-svg--slider-arrow-right" xmlns="http://www.w3.org/2000/svg" width="26" height="24.042">
                  <g transform="translate(1038.5 -1861.979) rotate(90)">
                      <rect width="17" height="2" transform="translate(1872.586 1037.086) rotate(-45)"></rect>
                      <rect width="25" height="2" transform="translate(1873 1037.5) rotate(-90)"></rect>
                      <rect width="17" height="2" transform="translate(1874 1038.5) rotate(-135)"></rect>
                  </g>
              </svg>
            <span className="qodef-m-text">COTIZAR</span>
          </a>
        </div>
      </div>

      <footer id="qodef-page-footer" role="contentinfo">
          <div id="qodef-page-footer-top-area">
              <div id="qodef-page-footer-top-area-inner" className="qodef-content-grid">
                  <div className="qodef-grid qodef-responsive--custom qodef-layout--template qodef-gutter--small qodef-alignment--left">
                      <div className="qodef-grid-inner clear">
                          <div className="qodef-grid-item qodef-col--4 qodef--1024-col-4 qodef--768-col-6 qodef--680-col-12">
                              <div id="block-61" className="widget widget_block widget_media_image" data-area="qodef-footer-top-area-column-1">
                                  <figure className="wp-block-image size-full">
                                      <img loading="lazy" decoding="async" width="962" height="962" src="img/logo.jpg" alt="" className="wp-image-6013" srcset="img/logo.jpg 962w, img/logo.jpg 600w, img/logo.jpg 300w, img/logo.jpg 768w" sizes="auto, (max-width: 962px) 100vw, 962px"/>
                                  </figure>
                              </div>
                          </div>
                          <div className="qodef-grid-item qodef-col--2 qodef--1024-col-4 qodef--768-col-6 qodef--680-col-12">
                              <div id="shiftup_core_title_widget-10" className="widget widget_shiftup_core_title_widget" data-area="qodef-footer-top-area-column-2">
                                  <span className="qodef-widget-title" style={{marginBottom: -10}}>Navegación</span>
                              </div>
                              <div id="nav_menu-2" className="widget widget_nav_menu" data-area="qodef-footer-top-area-column-2">
                                  <div className="menu-footer1-container">
                                      <ul id="menu-footer1" className="menu">
                                          <li id="menu-item-6898" className="menu-item">
                                              <a href="#page-top">Inicio</a>
                                          </li>
                                          <li id="menu-item-6893" className="menu-item current-menu-item">
                                              <a href="#Servicios" aria-current="page">Servicios</a>
                                          </li>
                                          <li id="menu-item-6894" className="menu-item">
                                              <a href="#SobreNosotros">Sobre Nosotros</a>
                                          </li>
                                          <li id="menu-item-6897" className="menu-item">
                                              <a href="#contacto">Contacto</a>
                                          </li>
                                      </ul>
                                  </div>
                              </div>
                          </div>
                          <div className="qodef-grid-item qodef-col--2 qodef--1024-col-4 qodef--768-col-6 qodef--680-col-12">
                              <div id="shiftup_core_title_widget-14" className="widget widget_shiftup_core_title_widget" data-area="qodef-footer-top-area-column-5">
                                  <span className="qodef-widget-title" style={{marginBottom: -10}}>Más</span>
                              </div>
                              <div id="nav_menu-5" className="widget widget_nav_menu">
                                  <div className="menu-footer4-container">
                                      <ul id="menu-footer4" className="menu">
                                          <li id="menu-item-6922" className="menu-item">
                                              <a onClick={handleClickWhatsaap} >WhatsApp</a>
                                          </li>
                                          <li id="menu-item-6923" className="menu-item">
                                              <a onClick={handleClickInstagram}>Instagram</a>
                                          </li>
                                      </ul>
                                  </div>
                              </div>
                          </div>

                          <div className="qodef-grid-item qodef-col--4 qodef--1024-col-4 qodef--768-col-6 qodef--680-col-12">
                              <div id="block-61" className="widget widget_block widget_media_image" data-area="qodef-footer-top-area-column-1">
                              <span className="qodef-widget-title" style={{marginBottom: -10}}>SERVICIO 100% SEGURO</span>
                                  <figure className="wp-block-image size-full">
                                      <img loading="lazy" decoding="async" width="255" height="86" src="img/garantia.png" alt="" className="wp-image-6013" srcset="img/garantia.png 962w, img/garantia.png 600w, img/garantia.png 300w, img/garantia.png 768w" sizes="auto, (max-width: 100px) 100vw, 567px"/>
                                  </figure>
                              </div>
                          </div>

                      </div>
                  </div>
              </div>
          </div>
                <div className="col-md-12">
                  <div className="row">
                    <div className="social">
                      <ul>
                        <li>
                          <a onClick={handleClickFacebook}>
                            <i className="fa fa-facebook"></i>
                          </a>
                        </li>
                        <li>
                          <a onClick={handleClickInstagram}>{/*  <a  href={props.data ? props.data.instagram : "/"}>*/} 
                            <i className="fa fa-instagram"></i>
                          </a>
                        </li>
                        <li>
                          <a onClick={handleClickYoutube}>
                            <i className="fa fa-youtube"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
      </footer>
        </div>
      </div>
 
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2024 CJ Performance. Design by{" "}
            <a href="https://cjperformanceservice.com/" rel="nofollow">
              ITechMaxSolutions
            </a>
          </p>
        </div>
      </div>

    </div>
  );
};
